import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const PlusIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 16,
  height = 16,
  customColour,
  ...rest
}) => {
  const className = customColour ? '' : 'interactiveColor'

  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <path
        d="M9,-8.8817842e-16 C9,-8.8817842e-16 9,2.33333333 9,7 L16,7 L16,9 L9,9 L9,16 L7,16 L7,9 L0,9 L0,7 L7,7 L7,-8.8817842e-16 C8.33333333,-8.8817842e-16 9,-8.8817842e-16 9,-8.8817842e-16 Z"
        data-testid="icon-plus"
        fill={customColour}
        className={styles[className]}
      />
    </Icon>
  )
}
